export const formatPriceWithSymbol = function (price) { // ¥ 金额格式化
    if (price == null) {
      return '-'
    }
    return '￥' + parseFloat(price).toFixed(0).replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), '$1,')
  }
  
  export const formatPrice = function (price) { // 金额
    if (price == null || price == 'undefined') {
      return '-'
    }
    return parseFloat(price).toFixed(0).replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), '$1,')
  }
  
  export const formatweekno = function (data) {
    if (!data) {
      return null
    }
    return data.substr(data.length - 2, data.length)
  }
  
  export const  formatDate = function (date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
      }
    }
    return fmt
  }
  
  export const setTitle = function(title) {
    setTimeout(function() {
        //利用iframe的onload事件刷新页面
        document.title = title
        var iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';
        iframe.style.width = '1px';
        iframe.style.height = '1px';
        iframe.onload = function() {
            setTimeout(function() {
                document.body.removeChild(iframe);
            }, 0);
        };
        document.body.appendChild(iframe);
    }, 0);
  }
  
  export const upperJsonKey = function(jsonObj){
    for (let key in jsonObj){
      jsonObj["\""+key.toUpperCase()+"\""] = jsonObj[key];
      delete(jsonObj[key]);
    }
    return jsonObj;
  }
  
  export default {
    formatweekno: formatweekno,
    formatPriceWithSymbol: formatPriceWithSymbol,
    formatPrice: formatPrice,
    formatDate:formatDate,
    setTitle:setTitle,
    upperJsonKey:upperJsonKey,
  }
  


// WEBPACK FOOTER //
// ./src/assets/js/util.js